import {
  AreaList,
  LevelList,
} from "@/services/backend/qpm/buildings/types/building";
import { LevelSegmentCollapsible } from "@/routes/processes/[processId]/qpm/manage-building/_components/level-segment-collapsible";
import { AddLevelComponent } from "@/services/backend/qpm/buildings/components/add-level";
import t from "@/lang/lang";
import {
  AreaType,
  LevelType,
} from "@/services/backend/qpm/buildings/types/building-enum";

export type BuildingLevelsComponentProps = {
  buildingId: string;
  levelList: LevelList;
  levelledAreas: AreaList;
  levelType?: LevelType;
  areaType?: AreaType;
};

export function BuildingLevelsComponent({
  buildingId,
  levelList,
  levelledAreas,
  levelType = LevelType.LevelTypeInside,
  areaType = AreaType.AreaTypeInside,
}: BuildingLevelsComponentProps) {
  return (
    <>
      {levelList &&
        levelList.map((level) => (
          <LevelSegmentCollapsible
            level={level}
            id={level.base.id}
            key={level.base.id}
            buildingId={buildingId}
            areas={(levelledAreas || []).filter(
              (area) => area.levelId === level.base.id,
            )}
            areaType={areaType}
          />
        ))}
      <div className="grid gap-4 p-4">
        {levelList && levelList.length <= 0 && (
          <p>{t("Es sind noch keine Ebenen vorhanden.")}</p>
        )}
        <AddLevelComponent buildingId={buildingId} levelType={levelType} />
      </div>
    </>
  );
}
